import React, { useEffect, useState } from "react";
import "./LpAbout.css";
export default function GoodwayScroll() {
  const [visibleLines, setVisibleLines] = useState(1);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      if (scrollY < 400) {
        setVisibleLines(1);
      } else if (scrollY < 600) {
        setVisibleLines(2);
      } else {
        setVisibleLines(3);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const getStyle = (isVisible) => ({
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? "translateY(0px)" : "translateY(-40px)",
    transition: "all 1s ease ",
  });

  return (
    <div className="lpScroll-container">
      <div className="lpScroll-content" style={getStyle(visibleLines >= 1)}>
        <span>G</span>oodway
      </div>
      <div className="lpScroll-content" style={getStyle(visibleLines >= 2)}>
        <span>A</span>ttestation And
      </div>
      <div className="lpScroll-content" style={getStyle(visibleLines >= 3)}>
        <span>A</span>postille
      </div>

      <div className="lpScroll-para">
        <p>
          At the heart of our service lies a deep commitment to excellence in
          certificate attestation and apostille solutions. With over 16 years of
          industry expertise and a team of seasoned professionals, we have built
          a strong reputation for delivering swift, accurate, and dependable
          services across the globe.
        </p>
        <p>
          As a REGISTERED and ISO 9001:2015 certified organization, we are
          officially recognized by government authorities and embassies alike.
          Our specialization spans the attestation, authentication, and
          legalization of a wide range of documents—be it educational, personal,
          or commercial. From degree certificates and birth or marriage
          documents to affidavits and more, we ensure every certificate is
          processed with the highest standards of integrity.
        </p>
        <p>
          We proudly offer 100% genuine attestation, backed by transparent
          processes and some of the most competitive rates in the market. When
          you choose us, you’re not just opting for a service—you’re gaining a
          trusted partner committed to handling your documentation with
          professionalism, precision, and care.
        </p>
        <p>
          Let us manage the complexities of paperwork, so you can move forward
          with confidence and peace of mind.
        </p>
      </div>
    </div>
  );
}
